import React from "react";
import { ShieldCheckIcon, ZapIcon, RefreshCwIcon, CreditCardIcon } from "lucide-react";
const badges = [{
  icon: ShieldCheckIcon,
  title: "Pago 100% Seguro",
  sub: "Encriptado SSL"
}, {
  icon: ZapIcon,
  title: "Acceso Inmediato",
  sub: "Descarga al instante"
}, {
  icon: RefreshCwIcon,
  title: "Garantía 7 Días",
  sub: "Reembolso total"
}, {
  icon: CreditCardIcon,
  title: "Paga en tu Moneda",
  sub: "Tarjeta o PayPal"
}];
export function TrustBadges() {
  return <section className="w-full border-y border-white/5 bg-[#0d0b22]" data-id="element-224" data-mp="37h3wmwqrcs51">
      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 px-4 py-6 sm:grid-cols-4 sm:px-6" data-id="element-225" data-mp="37gu534q2ecx8">
        {badges.map(b => <div key={b.title} className="flex items-center gap-3" data-id="element-226" data-mp="3h6vqfor19h8g">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-violet-500/15 text-violet-300" data-id="element-227" data-mp="3h7p1v30xsuwx">
              <b.icon className="h-5 w-5" data-id="element-228" data-mp="3q7lm8sgan7m6" />
            </div>
            <div data-id="element-229" data-mp="3q9542nhllqq2">
              <p className="text-sm font-semibold text-white" data-id="element-230" data-mp="3q5h8zjwi8w98">{b.title}</p>
              <p className="text-xs text-slate-400" data-id="element-231" data-mp="2ptr3lqh8vyja">{b.sub}</p>
            </div>
          </div>)}
      </div>
    </section>;
}